import { HTTP } from "@/http-common";
import { createHelpers } from "vuex-map-fields";
import { httpError } from "@/models/httpError";
import { getField, updateField } from "vuex-map-fields";

export const { mapFields: mapReportsFields } = createHelpers({
  getterType: `reports/getField`,
  mutationType: `reports/updateField`
});

const state = {};

const actions = {
  getReport({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      HTTP.post("Report/Generate", data, { responseType: "arraybuffer" })
        .then(res => {
          let blob = new Blob([res.data], {
            type: data.type == "xlsx" ? "application/xlsx" : "image/png"
          });

          resolve(blob);
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error" + err.message,
              httpStatus: 500
            }),
            { root: true }
          );
          reject(err);
        });
    });
  }
};

const mutations = {
  setDealer(state, dealer) {
    state.dealer = dealer;
  },

  updateField
};

const getters = {
  getField
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
